// extracted by mini-css-extract-plugin
module.exports = {"button":"LoginTokenDialog_button__2oTkw","warning-color":"LoginTokenDialog_warning-color__2cMo5"};